
import Vue from 'vue'

export default class ContentFooter extends Vue {}
